import React from 'react';
import Loader from 'react-loader-spinner';

const LoadingButton = ({ label, btnClass, submitting, status, ...rest }) => (
    <button className={btnClass} disabled={status} {...rest}>
        {submitting ? (
            <Loader type='TailSpin' height={24} color='#ffffff' className='loader' />
        ) : (
            <p>{label}</p>
        )}
    </button>
);

export default LoadingButton;
